import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.47779 2.40453C3.34782 2.36678 3.21006 2.36489 3.07911 2.39908C2.94817 2.43326 2.82891 2.50224 2.73398 2.5987C2.63906 2.69517 2.572 2.81552 2.53992 2.947C2.50785 3.07848 2.51195 3.21619 2.55179 3.34553L4.98379 11.2505H13.4998C13.6987 11.2505 13.8895 11.3296 14.0301 11.4702C14.1708 11.6109 14.2498 11.8016 14.2498 12.0005C14.2498 12.1994 14.1708 12.3902 14.0301 12.5309C13.8895 12.6715 13.6987 12.7505 13.4998 12.7505H4.98379L2.55179 20.6555C2.51218 20.7848 2.50826 20.9224 2.54044 21.0537C2.57263 21.185 2.63971 21.3052 2.7346 21.4015C2.82949 21.4979 2.94865 21.5667 3.07947 21.6009C3.2103 21.635 3.34793 21.6332 3.47779 21.5955C10.0928 19.6718 16.3307 16.6328 21.9228 12.6095C22.0194 12.5401 22.0981 12.4486 22.1524 12.3427C22.2067 12.2368 22.235 12.1195 22.235 12.0005C22.235 11.8815 22.2067 11.7642 22.1524 11.6583C22.0981 11.5524 22.0194 11.461 21.9228 11.3915C16.3308 7.36783 10.0928 4.32849 3.47779 2.40453Z"
        fill={colorValue}
      />
    </svg>
  );
};
